import { Pipe, PipeTransform } from '@angular/core';
import { Fleet } from '../interfaces/fleet';

@Pipe({
    name: 'fleetFilter',
    standalone: false
})
export class FleetFilterPipe implements PipeTransform {

  transform(fleets: Fleet[] | undefined, starSystemId: string | undefined, status: string | undefined = undefined) {
    if (fleets == undefined || (starSystemId == undefined && status == undefined)) {
      return fleets;
    }

    return fleets.filter( fleet => {
      let meetsCriteria = true;
      if (starSystemId) {
        meetsCriteria = fleet.starSystemId === starSystemId
      }
      if (meetsCriteria && status) {
        meetsCriteria = fleet.status === status
      }
      return meetsCriteria;
    });
  }
}
